const ROW_INTERACTIVE_SELECTOR = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  'label',
  'summary',
  '[role="button"]',
  '[role="menuitem"]',
  '[role="menu"]',
  '[role="checkbox"]',
  '[role="switch"]',
].join(', ');

export function isRowInteractiveTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(ROW_INTERACTIVE_SELECTOR) != null;
}

export function isNewTabModifier(
  event: Pick<MouseEvent, 'metaKey' | 'ctrlKey' | 'button'> | Pick<KeyboardEvent, 'metaKey' | 'ctrlKey'>,
): boolean {
  if ('button' in event && event.button === 1) return true;
  return event.metaKey || event.ctrlKey;
}

export function activateRowHref(
  event: {
    target: EventTarget | null;
    metaKey: boolean;
    ctrlKey: boolean;
    button?: number;
    preventDefault: () => void;
  },
  href: string,
  navigate: (href: string) => void,
): boolean {
  if (isRowInteractiveTarget(event.target)) return false;
  event.preventDefault();
  if (isNewTabModifier(event)) {
    window.open(href, '_blank', 'noopener,noreferrer');
    return true;
  }
  navigate(href);
  return true;
}

export function activateRowHrefOnKey(
  event: {
    key: string;
    target: EventTarget | null;
    metaKey: boolean;
    ctrlKey: boolean;
    preventDefault: () => void;
  },
  href: string,
  navigate: (href: string) => void,
): boolean {
  if (event.key !== 'Enter') return false;
  return activateRowHref(event, href, navigate);
}
